export const DEFAULT_SITE_SETTINGS = {
  visual: {
    theme_palette: "vissera-gold",
    theme: {
      bg_primary: "#FDFBF7",
      bg_secondary: "#F5F2EB",
      bg_dark: "#1A1A1A",
      accent: "#B8860B",
      accent_hover: "#DAA520",
      accent_soft: "#C9A961",
      text_primary: "#111111",
      text_secondary: "#4B4B4B",
      text_muted: "#6B6B6B",
      border_light: "#E5E0D8",
      button_text: "#FFFFFF",
      interactive_bg: "#1A1A1A",
      interactive_text: "#FFFFFF",
    },
    logos: {
      header: { url: "", max_height: 44, object_fit: "contain", align: "left" },
      footer: { url: "", max_height: 52, object_fit: "contain", align: "left" },
    },
    favicon: { url: "/favicon-192x192.png", theme_color: "#000000" },
  },
  seo: {
    site_url: "https://xcompany.sevincmedia.com",
    company_name: "Vissera",
    tagline: "Trusted precious metals trade from Istanbul to the world.",
    default_title: "Vissera | Precious Metals Trading",
    title_template: "%s | Vissera",
    default_description:
      "Vissera manages secure import, export and sourcing of investment-grade gold and silver with trusted global delivery.",
    default_keywords: "Vissera, precious metals, gold trading, silver trading, Istanbul, bullion",
    og_image_url: "/social-preview.png",
    twitter_handle: "",
    robots: "index,follow",
  },
};
